export const BRAND = {
  "clientId": "ruttia",
  "displayName": "Ruttia",
  "legalName": "Ruttia",
  "web": {
    "appTitle": "Ruttia",
    "loginTitle": "Login",
    "apiBaseUrl": "https://api.ruttiaapp.com/api",
    "publicUrl": "",
    "primaryColor": "#0B5FFF",
    "secondaryColor": "#0F172A",
    "accentColor": "#14B8A6",
    "supportEmail": "",
    "hideForbiddenActions": true,
    "showMenuIcons": false,
    "assetUrls": {
      "logoFull": "",
      "logoMark": "",
      "favicon": "",
      "appleTouchIcon": "",
      "ogImage": ""
    }
  }
} as const;
